<div class="container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>

  <!-- FORM BOARDERS -->
  <div  class="card-form">
    <!-- BLUE BANNER -->
    <div class="blue-top" style="display: flex; align-items: center; box-sizing: border-box; padding: 24px; padding-top: 24px;">
      <h2 style="color: white!important; font-weight: 500; margin-bottom: 0px !important;">
        {{'Detailed claim form'}}
      </h2>
    </div>
    <!-- FORM STEPS -->
    <mat-stepper [orientation]="(stepperOrientation | async)!" (selectionChange)="onStepChange($event)" #stepper [linear]="true">
      <!-- Step 2 motorForm 2 -->
      <mat-step [stepControl]="motorForm2" label="">
        <form [formGroup]="motorForm2" (ngSubmit)="submitForm()" novalidate>
          <!-- FORM INPUTS -->
          <div class="card-section top-section">
            <h2>Details of the incident</h2>
            <p>Was the vehicle in use at the time of the incident?</p>
            <!-- WAS VEHICLE IN USE -->
            <section class="row-div modified_checkbox" formGroupName="isVehicleUse">
              <div class="row-inner-div row-inner-div-left">
                <mat-checkbox formControlName="yes" (change)="onYesChange(motorForm2, 'isVehicleUse')">
                  Yes
                </mat-checkbox>
              </div>
              <div class="row-inner-div row-inner-div-right">
                <mat-checkbox formControlName="no" (change)="onNoChange(motorForm2, 'isVehicleUse')">
                  No
                </mat-checkbox>
              </div>
            </section>
            <!-- IF VEHICLE USE -->
            <mat-form-field *ngIf="motorForm2.controls['isVehicleUse'].controls['yes'].value === true"
              appearance="outline" class="form-select" style="margin-bottom: 8px;" >
                <mat-label class="form-select-placeholder-unselected">
                    Use of the vehicle at the time of the accident
                </mat-label>
                <textarea matInput formControlName="vehicleUse"
                  placeholder="Use of the vehicle at the time of the incident"
                  (blur)="logErrors()"
                  style="height: 70px;">
                </textarea>
                <mat-error *ngIf="formErrors['vehicleUse']">
                    This field is required
                </mat-error>
            </mat-form-field>
          </div>

          <div class="card-section bottom-section">
            <h2>Goods being carried by the vehicle</h2>
            <p style="margin-bottom: 8px;">Was the vehicle carrying any goods at the time of the incident?</p>
            <!-- WERE GOODS CARRIED? -->
            <section class="row-div modified_checkbox" formGroupName="isCarryingGoods">
              <div class="row-inner-div row-inner-div-left">
                <mat-checkbox formControlName="yes" (change)="onYesChange(motorForm2, 'isCarryingGoods')">
                  Yes
                </mat-checkbox>
              </div>
              <div class="row-inner-div row-inner-div-right">
                <mat-checkbox formControlName="no" (change)="onNoChange(motorForm2, 'isCarryingGoods')">
                  No
                </mat-checkbox>
              </div>
            </section>
            <!-- IF GOODS CARRIED -->
            <div style="width: 100%;" *ngIf="motorForm2.controls['isCarryingGoods'].controls['yes'].value === true">
              <!-- DESCRIPTION OF GOODS -->
              <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px; width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                  Description of goods being carried
                </mat-label>
                <textarea matInput formControlName="goodsDesc"
                  placeholder="Description of goods being carried"
                  (blur)="logErrors()"
                  style="height: 70px;">
                </textarea>
                <mat-error *ngIf="formErrors['goodsDesc']">
                  This field is required
                </mat-error>
              </mat-form-field>
              <!-- OWNER NAME -->
              <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px; width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                  Name of owner of goods
                </mat-label>
                <input matInput formControlName="goodsOwner" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['goodsOwner']">
                  This field is required
                </mat-error>
              </mat-form-field>
              <!-- TRAILER REG MARKS -->
              <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px; width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                    Trailer Reg Marks
                </mat-label>
                <input matInput formControlName="trailerRegMarks" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['trailerRegMarks']">
                  This field is required
                </mat-error>
              </mat-form-field>
              <!-- LOAD WEIGHT -->
              <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 16px; width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                    Weight of load on the vehicle
                </mat-label>
                <input matInput formControlName="goodsWeight" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['goodsWeight']">
                  This field is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- ACTION BUTTONS -->
          <div class="card-section bottom-section">
            <div class="row-div">
              <button mat-stroked-button type="button" (click)="confirmCancel()">
                  <span class="button-text">Previous</span>
              </button>
              <button mat-button type="submit" [disabled]="!motorForm2.valid">
                  <span class="button-text">Next</span>
              </button>
            </div>
          </div>
        </form>
      </mat-step>
      <!-- Step 3 motorForm 3 -->
      <mat-step [stepControl]="motorForm3" label="">
        <form [formGroup]="motorForm3" (ngSubmit)="submitForm()" novalidate>
          <!-- FORM INPUTS -->
          <div class="card-section top-section">
            <h2>Driver details</h2>
            <!-- WERE YOU DRIVER? -->
            <p>Was someone else other than the insured driving the vehicle / or with the vehicle at the time of the incident?</p>
            <section class="row-div modified_checkbox" formGroupName="otherDriver">
              <div class="row-inner-div row-inner-div-left">
                <mat-checkbox formControlName="yes" (change)="onYesChange(motorForm3, 'otherDriver')">
                  Yes
                </mat-checkbox>
              </div>
              <div class="row-inner-div row-inner-div-right">
                <mat-checkbox formControlName="no" (change)="onNoChange(motorForm3, 'otherDriver')">
                  No
                </mat-checkbox>
              </div>
            </section>
            <!-- IF NOT DRIVER -->
            <div *ngIf="motorForm3.controls['otherDriver'].controls['yes'].value === true" style=" width: 100%;">
              <!-- DRIVER NAME -->
              <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px; width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                    Name of driver
                </mat-label>
                <input matInput formControlName="driverName" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['driverName']">
                  This field is required
                </mat-error>
              </mat-form-field>
              <!-- DRIVER ID -->
              <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px; width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                  ID Number
                </mat-label>
                <input matInput formControlName="driverID" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['driverID']">
                  This field is required
                </mat-error>
              </mat-form-field>
              <!-- DRIVER PHONE -->
              <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px; width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                  Phone number
                </mat-label>
                <input matInput formControlName="driverPhone" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['driverPhone']">
                  This field is required
                </mat-error>
              </mat-form-field>
              <!-- DRIVER DOB -->
              <mat-form-field [hideRequiredMarker]="true" appearance="outline" class="form-select" appFullYearDateFormat style=" width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                  Date of birth
                </mat-label>
                <input
                  matInput
                  [min]="minDobDate"
                  [max]="maxDobDate"
                  [matDatepicker]="pickerX"
                  readonly="true"
                  (click)="pickerX.open()"
                  formControlName="driverDOB"
                  (blur)="logErrors()"
                />

                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickerX"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickerX> </mat-datepicker>
              </mat-form-field>
              <!-- OCCUPATION -->
              <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px; width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                  Occupation
                </mat-label>
                <input matInput formControlName="driverOccupation" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['driverOccupation']">
                  This field is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <!-- IF NOT DRIVER -->
          <div class="card-section bottom-section">
            <!-- DRIVER LIABILITY -->
            <p>Did the driver admit liability?</p>
            <section class="row-div modified_checkbox" formGroupName="driverAdmitLiability">
              <div class="row-inner-div row-inner-div-left">
                <mat-checkbox formControlName="yes" (change)="onYesChange(motorForm3, 'driverAdmitLiability')">
                  Yes
                </mat-checkbox>
              </div>
              <div class="row-inner-div row-inner-div-right">
                <mat-checkbox formControlName="no" (change)="onNoChange(motorForm3, 'driverAdmitLiability')">
                  No
                </mat-checkbox>
              </div>
            </section>
            <!-- DRIVER ACCIDENTS -->
            <p>Has the driver had any previous accidents?</p>
            <section class="row-div modified_checkbox" formGroupName="driverHasAccidents">
              <div class="row-inner-div row-inner-div-left">
                <mat-checkbox formControlName="yes" (change)="onYesChange(motorForm3, 'driverHasAccidents')">
                  Yes
                </mat-checkbox>
              </div>
              <div class="row-inner-div row-inner-div-right">
                <mat-checkbox formControlName="no" (change)="onNoChange(motorForm3, 'driverHasAccidents')">
                  No
                </mat-checkbox>
              </div>
            </section>
            <!-- NO. OF ACCIDENTS -->
            <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px; width: 100%;"
              *ngIf="motorForm3.controls['driverHasAccidents'].controls['yes'].value === true"
            >
              <mat-label class="form-select-placeholder-unselected">
                How many accidents?
              </mat-label>
              <input type="number" matInput formControlName="driverAccidentNum" (blur)="logErrors()">
              <mat-error *ngIf="formErrors['driverAccidentNum']">
                This field is required
              </mat-error>
            </mat-form-field>
            
            <div *ngIf="motorForm3.controls['otherDriver'].controls['yes'].value === true" style=" width: 100%;">
              <!-- IS DRIVER EMPLOYEE -->
              <p>Is the driver your employee?</p>
              <section class="row-div modified_checkbox" formGroupName="driverEmployee">
                <div class="row-inner-div row-inner-div-left">
                  <mat-checkbox formControlName="yes" (change)="onYesChange(motorForm3, 'driverEmployee')">
                    Yes
                  </mat-checkbox>
                </div>
                <div class="row-inner-div row-inner-div-right">
                  <mat-checkbox formControlName="no" (change)="onNoChange(motorForm3, 'driverEmployee')">
                    No
                  </mat-checkbox>
                </div>
              </section>
              <!-- DRIVER PERMISSION -->
              <p>Was the driver driving with your permission?</p>
              <section class="row-div modified_checkbox" formGroupName="driverPermission">
                <div class="row-inner-div row-inner-div-left">
                  <mat-checkbox formControlName="yes" (change)="onYesChange(motorForm3, 'driverPermission')">
                    Yes
                  </mat-checkbox>
                </div>
                <div class="row-inner-div row-inner-div-right">
                  <mat-checkbox formControlName="no" (change)="onNoChange(motorForm3, 'driverPermission')">
                    No
                  </mat-checkbox>
                </div>
              </section>
              <!-- DRIVER EXPERIENCE -->
              <mat-form-field appearance="outline" class="form-select" style=" width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                  Period driver has been driving the vehicle
                </mat-label>
                <input matInput formControlName="driverExperience" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['driverExperience']">
                  This field is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>



          <!-- STATEMENTS -->
          <div class="card-section bottom-section">
            <!-- DRIVER STATEMENT -->
            <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px;" *ngIf="motorForm3.controls['otherDriver'].controls['yes'].value === true">
              <mat-label class="form-select-placeholder-unselected">
                Detailed statement by the driver
              </mat-label>
              <textarea matInput formControlName="driverStatement"
                placeholder="Detailed statement by the driver"
                (blur)="logErrors()"
                style="height: 70px;">
              </textarea>
              <mat-error *ngIf="formErrors['driverStatement']">
                This field is required
              </mat-error>
            </mat-form-field>
            <!-- OWNER STATEMENT -->
            <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px;" >
              <mat-label class="form-select-placeholder-unselected">
                Detailed statement by the owner
              </mat-label>
              <textarea matInput formControlName="ownerStatement"
                placeholder="Detailed statement by the owner"
                (blur)="logErrors()"
                style="height: 70px;">
              </textarea>
              <mat-error *ngIf="formErrors['ownerStatement']">
                This field is required
              </mat-error>
            </mat-form-field>
          </div>

          <!-- ACTION BUTTONS -->
          <div class="card-section bottom-section">
              <div class="row-div">
                  <button mat-stroked-button type="button" (click)="confirmCancel()">
                      <span class="button-text">Previous</span>
                  </button>
                  <button mat-button type="submit" [disabled]="!motorForm3.valid">
                      <span class="button-text">Next</span>
                  </button>
              </div>
          </div>
        </form>
      </mat-step>
      <!-- Step 4 motorForm 4-->
      <mat-step [stepControl]="motorForm4" label="">
        <form [formGroup]="motorForm4" (ngSubmit)="submitForm()" novalidate>
          <!-- FORM INPUTS -->
          <div class="card-section top-section">
            <h2>Please provide details of the garage repairing the vehicle</h2>
            <!-- YES TO REPAIRS (REPAIRER)-->
            <!-- REPAIRER NAME -->
            <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px;">
              <mat-label class="form-select-placeholder-unselected">
                  Name of repairer
              </mat-label>
              <input matInput formControlName="garageName" (blur)="logErrors()">
              <mat-error *ngIf="formErrors['garageName']">
                This field is required
              </mat-error>
            </mat-form-field>
            <!-- REPAIRER PHONE -->
            <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px;">
              <mat-label class="form-select-placeholder-unselected">
                Phone number
              </mat-label>
              <input matInput formControlName="garagePhone" (blur)="logErrors()">
              <mat-error *ngIf="formErrors['garagePhone']">
                This field is required
              </mat-error>
            </mat-form-field>
          </div>
          <!-- DAMAGES AND INJURIES -->
          <div class="card-section bottom-section">
            <h2>Other vehicles involved, property damaged and persons injured</h2>
            <!-- OTHER VEHICLES? -->
            <p>Were there other vehicles involved in the incident?</p>
            <section class="row-div modified_checkbox" formGroupName="othersInvolved">
              <div class="row-inner-div row-inner-div-left">
                <mat-checkbox formControlName="yes" (change)="onYesChange(motorForm4, 'othersInvolved')">
                  Yes
                </mat-checkbox>
              </div>
              <div class="row-inner-div row-inner-div-right">
                <mat-checkbox formControlName="no" (change)="onNoChange(motorForm4, 'othersInvolved')">
                  No
                </mat-checkbox>
              </div>
            </section>
            <!-- OTHERS ARRAY -->
            <div style="display: flex; flex-direction: column; width: 100%;" *ngIf="motorForm4.controls['othersInvolved'].controls['yes'].value === true">
              <div formArrayName="others">
                <div style="display: flex; flex-direction: column; width: 100%;" *ngFor="let other of getOthers().controls; let i=index" [formGroupName]="i">
                  <!-- Remove -->
                  <div class="row-div-reverse remove-stroked-button" *ngIf="i > 0">
                    <button mat-stroked-button type="button" (click)="removeOther(i)">
                      <span class="button-text">remove</span>
                    </button>
                  </div>
                  <!-- Registration mark -->
                  <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px;">
                    <mat-label class="form-select-placeholder-unselected">
                      Registration mark
                    </mat-label>
                    <input matInput formControlName="regMark" (blur)="logErrors()">
                    <mat-error *ngIf="formErrors['regMark']">
                      This field is required
                    </mat-error>
                  </mat-form-field>
                  <!-- Name of owner -->
                  <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px;">
                    <mat-label class="form-select-placeholder-unselected">
                      Name of owner
                    </mat-label>
                    <input matInput formControlName="owner" (blur)="logErrors()">
                    <mat-error *ngIf="formErrors['owner']">
                      This field is required
                    </mat-error>
                  </mat-form-field>
                  <!-- Damages -->
                  <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px;">
                    <mat-label class="form-select-placeholder-unselected">
                      Brief description of any damages incurred to third party
                    </mat-label>
                    <textarea matInput formControlName="damages" placeholder="Brief description of any damages incurred"
                      (blur)="logErrors()" style="height: 70px;">
                    </textarea>
                    <mat-error *ngIf="formErrors['damages']">
                      This field is required
                    </mat-error>
                  </mat-form-field>
                  <!-- Has injured passengers? -->
                  <p>Was any passenger in this vehicle injured in the incident?</p>
                  <section class="row-div modified_checkbox" formGroupName="hasInjuries">
                    <div class="row-inner-div row-inner-div-left">
                      <mat-checkbox formControlName="yes" (change)="onYesChange(getOthersFormgroup(i), 'hasInjuries', i)">
                        Yes
                      </mat-checkbox>
                    </div>
                    <div class="row-inner-div row-inner-div-right">
                      <mat-checkbox formControlName="no" (change)="onNoChange(getOthersFormgroup(i), 'hasInjuries', i)">
                        No
                      </mat-checkbox>
                    </div>
                  </section>

                  <!-- YES INJURIES ARRAY -->
                  <div style="display: flex; flex-direction: column; width: 100%;" *ngIf="getOthers().at(i).get('hasInjuries')?.get('yes')?.value === true">
                    <div formArrayName="injuredPassengers">
                      <div style="display: flex; flex-direction: column; width: 100%;" *ngFor="let witness of getInjuries(i).controls; let j=index" [formGroupName]="j">
                        <!-- Remove -->
                        <div class="row-div-reverse remove-stroked-button" *ngIf="j > 0">
                          <button mat-stroked-button type="button" (click)="removeInjured(i, j)">
                            <span class="button-text">remove</span>
                          </button>
                        </div>
                        <!-- Name of injured passenger -->
                        <mat-form-field appearance="outline" class="form-select" style="margin-bottom: -5px;">
                          <mat-label class="form-select-placeholder-unselected">
                            Name of injured passenger
                          </mat-label>
                          <input matInput formControlName="name" (blur)="logErrors()">
                          <mat-error *ngIf="formErrors['name']">
                            This field is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <!-- BUTTTON aDD INJURED -->
                    <div class="row-div general-stroked-button"
                      style="flex-direction: row-reverse; border-bottom: 0.5px solid #e5e5e5; margin-bottom: 16px; margin-top: 0px; padding-bottom: 8px;">
                      <button mat-stroked-button type="button" (click)="addInjured(i)">
                        <span class="button-text">+&nbsp;&nbsp;
                          Add Passenger
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- BUTTTON aDD VEHICLE -->
              <div class="row-div general-stroked-button">
                <button mat-stroked-button type="button" (click)="addNewOther()">
                  <span class="button-text">+&nbsp;&nbsp;
                    Add Vehicle
                  </span>
                </button>
              </div>
            </div>
          </div>

          <!-- PASSENGERS IN YOUR VEHICLE -->
          <div class="card-section bottom-section">
            <h2>Passengers in your vehicle</h2>
            <p>Were there other passengers in your vehicle?</p>
            <section class="row-div modified_checkbox" formGroupName="hasPassengers">
              <div class="row-inner-div row-inner-div-left">
                <mat-checkbox formControlName="yes" (change)="onYesChange(motorForm4, 'hasPassengers')">
                  Yes
                </mat-checkbox>
              </div>
              <div class="row-inner-div row-inner-div-right">
                <mat-checkbox formControlName="no" (change)="onNoChange(motorForm4, 'hasPassengers')">
                  No
                </mat-checkbox>
              </div>
            </section>
            <!-- PASSENGERS ARRAY -->
            <div *ngIf="motorForm4.controls['hasPassengers'].controls['yes'].value === true">
              <div formArrayName="passengers">
                <div style="display: flex; flex-direction: column; width: 100%;" *ngFor="let witness of getPassengers().controls; let i=index" [formGroupName]="i">
                  <!-- Remove -->
                  <div class="row-div-reverse remove-stroked-button" *ngIf="i > 0">
                    <button mat-stroked-button type="button" (click)="removePassenger(i)">
                      <span class="button-text">remove</span>
                    </button>
                  </div>
                  <!-- Passenger name -->
                  <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 8px;">
                    <mat-label class="form-select-placeholder-unselected">
                        Name of passenger
                    </mat-label>
                    <input matInput formControlName="name" (blur)="logErrors()">
                    <mat-error *ngIf="formErrors['name']">
                      This field is required
                    </mat-error>
                  </mat-form-field>
                  <!-- Passenger relationship -->
                  <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 16px;">
                    <mat-label class="form-select-placeholder-unselected">
                      Relationship
                    </mat-label>
                    <input matInput formControlName="relationship" (blur)="logErrors()">
                    <mat-error *ngIf="formErrors['relationship']">
                      This field is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <!-- BUTTTON aDD PASSENGER -->
              <div class="row-div general-stroked-button">
                <button mat-stroked-button type="button" (click)="addNewPassenger()">
                  <span class="button-text">+&nbsp;&nbsp;
                    Add Passenger
                  </span>
                </button>
              </div>
            </div>
            
          </div>

          <div class="simple_checkbox width-100pc margin-bottom-40 margin-top-30">
            <mat-checkbox formControlName="iSwear" (blur)="logErrors()" style="margin-bottom: 10px;">
              <p class="checkbox-p" [innerHTML]="iSwearText | dompurify"></p>
            </mat-checkbox>
            <mat-error *ngIf="formErrors['iSwear']">
              {{formErrors["iSwear"]}}
            </mat-error>
        </div>

          <!-- ACTION BUTTONS -->
          <div class="card-section bottom-section">
            <div class="row-div">
                <button mat-stroked-button type="button" (click)="confirmCancel()">
                    <span class="button-text">Previous</span>
                </button>
                <button mat-button type="submit" [disabled]="motorForm4.controls['iSwear'].value === false || !motorForm4.valid">
                    <span class="button-text">Save and Continue</span>
                </button>
            </div>
          </div>
        </form>
      </mat-step>
    </mat-stepper>
  </div>
</div>
